import type {SymbolKind} from '@github-ui/code-nav'
import {clsx} from 'clsx'

import styles from './SymbolIndicator.module.css'

export function SymbolIndicator({symbolKind, showFullSymbol}: {symbolKind: SymbolKind; showFullSymbol?: boolean}) {
  if (!symbolKind) {
    return null
  }

  return (
    <div className={clsx(styles.symbolWrapper, !showFullSymbol && styles.symbolWrapperCompact)}>
      <div className={styles.symbolBackground} style={{backgroundColor: symbolKind.plColor}} />
      <div
        className={clsx(styles.symbolLabel, showFullSymbol ? styles.symbolLabelMedium : styles.symbolLabelSmall)}
        style={{color: symbolKind.plColor}}
      >
        {showFullSymbol ? symbolKind.fullName : symbolKind.shortName}
      </div>
    </div>
  )
}
